<h1 mat-dialog-title>Question</h1>
<div mat-dialog-content>
    <p>Please tell us what your question is. You do not need to give us the guest information. It will be sent with your question.</p>
    <mat-form-field appearance="fill" class="w-100 mt-1">
        <textarea class="question-input" rows="10" matInput [(ngModel)]="question"></textarea>
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-raised-button (click)="onCancelClick()" style="margin-right:12px;">Cancel</button>
    <button mat-raised-button class="action-button" (click)="onSendClick()">Send</button>
</div>